import React, { useEffect, useRef } from 'react';
import { NavigateOptions, To, useNavigate } from 'react-router-dom';

import { eventEmitter } from 'config';
import { EventEmitterEvent } from 'enums';

export const NavigateListener: React.FC = () => {
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;

  useEffect(() => {
    const handler = (data: { to: To; options?: NavigateOptions }) => {
      navigateRef.current(data.to, data.options);
    };
    eventEmitter.on(EventEmitterEvent.Navigate, handler);
    return () => {
      eventEmitter.off(EventEmitterEvent.Navigate, handler);
    };
  }, []);
  return null;
};
